import { Component, Shark, Utils } from "shark-mvc";

import templateContent from "./show-all-contacts-button.html";
import templateAllContactBox from "./all-contacts-box.html";
import templateAllIconCardsCol from "./all-icon-cards-column.html";

class ShowAllContactsButtonComponent extends Component {
	constructor () {
		super("showAllContactsButtonComponent");
		this.addTemplate("", templateContent);
		this.addTemplate("allContactBox", templateAllContactBox);
		this.addTemplate("allIconCardsCol", templateAllIconCardsCol);
	}

	init () {
		let defaultSettings = {
			showAllContacts: false,
		};
		let showAllContactsButtonStatusSettings = localStorage.getItem("showAllContactsButtonStatusSettings");

		if (showAllContactsButtonStatusSettings) {
			showAllContactsButtonStatusSettings = JSON.parse(showAllContactsButtonStatusSettings);
			Object.assign(defaultSettings, showAllContactsButtonStatusSettings);
		}

		const showAllContactsButtonStatus = Shark.getInstance("__smart__", defaultSettings);

		showAllContactsButtonStatus.on("dataChanged", function (data) {
			localStorage.setItem("showAllContactsButtonStatusSettings", JSON.stringify(this.export()));
			Shark.render();
		});

		Shark.set({showAllContactsButtonStatus});
	}
}

const showAllContactsButtonComponent = new ShowAllContactsButtonComponent();

Shark.registerComponent(showAllContactsButtonComponent);

export default showAllContactsButtonComponent;
